//////////////////
// IMPORTS
//////////////////
// libraries
import * as React from "react";
// material-ui
import { CircularProgressProps } from "@material-ui/core/CircularProgress/CircularProgress";
import CircularProgress from "@material-ui/core/CircularProgress";

interface IProps extends CircularProgressProps {
  contained?: boolean;
  width?: number | string;
  height?: number | string;
  size?: number;
}

interface IState {}

//////////////////
// COMPONENT
//////////////////
export class Loader extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
  }

  public render() {
    const { contained, width, height, ...cpProps } = this.props;
    cpProps.size = cpProps.size || 80;
    cpProps.thickness = cpProps.thickness || 3;
    const halfSize = cpProps.size / 2;

    const style: React.CSSProperties = {
      position: "absolute",
      width: cpProps.size,
      height: cpProps.size,
      top: `calc(50% - ${halfSize}px)`,
      left: `calc(50% - ${halfSize}px)`,
    };

    const cp = (
      <div style={style}>
        <CircularProgress {...cpProps} />
      </div>
    );

    if (contained) {
      const containerStyle: React.CSSProperties = {
        width,
        height,
        position: "relative",
      };

      return <div style={containerStyle}>{cp}</div>;
    }

    return cp;
  }
}
